export function DateFormat(dateFmt, clockFmt) {
    this.dateFormat = dateFmt;
    this.clockFormat = clockFmt;
    this.formatDate = formatDate;
    this.formatTime = (date) => formatTime(date, this.clockFormat);
    this.formatDateTime = formatDateTime;
    this.getShortTime = (date, initialFormat) => getShortTime(date, initialFormat, this.clockFormat);
}

function formatDate(d) {
    var result = this.dateFormat;
    var tokens = this.dateFormat.split(/[ \/,-]+/, 4);

    for (var i=0; i<tokens.length; i++) {
        if (tokens[i] == 'MM')
            result = result.replace(/MM/, getNumWithLeadingZero(d.getMonth() + 1));
        else if (tokens[i] == 'MMM')
            result = result.replace(/MMM/, Date.monthNamesShort[d.getMonth()]);
        else if (tokens[i] == 'MMMM')
            result = result.replace(/MMMM/, Date.monthNames[d.getMonth()]);
        else if (tokens[i] == 'dd')
            result = result.replace(/dd/, getNumWithLeadingZero(d.getDate()));
        else if (tokens[i] == 'yy')
            result = result.replace(/yy/, getShortYear(d.getFullYear()));
        else if (tokens[i] == 'yyyy')
            result = result.replace(/yyyy/, d.getFullYear());
        else if (tokens[i] == 'EEE')
            result = result.replace(/EEE/, Date.dayNamesShort[d.getDay()]);
        else if (tokens[i] == 'EEEE')
            result = result.replace(/EEEE/, Date.dayNames[d.getDay()]);
    }

    return result;
}

export function formatTime(date, clockFormat) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes;
    return clockFormat ? ClassicBridge.convertTimeToFormat(strTime, true, clockFormat) : strTime;
}

function formatDateTime(date) {
    return this.formatDate(date) + ", " + this.formatTime(date);
}


function getNumWithLeadingZero(num) {
    if (num < 10) return new String('0' + num);
    return num;
}

function getShortYear(year) {
    return new String(year).substring(2, 4);
}

export function getShortTime(date, initialFormat, clockFormat) {
    const timeFormat = (clockFormat || SystemSettings.clockFormat) === "12" ? "h:i A" : "H:i"
    return date ? Date.parseDate(date, initialFormat).format("M d, " + timeFormat) : null;
}



// WEBPACK FOOTER //
// ./web/js/date_format.js